<template>
  <div class="d-flex flex-column flex-root px-20">
      <!-- begin:: Content -->
      <span
        class="font-size-h2 font-weight-boldest text-dark-75 mt-15 mb-5"
      >
        Privacy Policy
      </span>
      <p class="font-size-h3 font-weight-light">
        This Privacy Notice applies to personal information we collect and process on all Bureau of Internal Revenue (BIR) forms, website and online services.
        <br/><br/>
        Personal information refers to any information, whether recorded in material form or not, that will directly ascertain your identity. This includes your address and contact information.
        <br/><br/>
        Sensitive personal information is personal information that includes your age, date of birth, marital status, social security and other government identification numbers, financial information and tax returns.
        <br/><br/>
        <span class="font-weight-bolder">WHAT PERSONAL INFORMATION WE COLLECT</span>
        <br/><br/>
        We process and collect personal information for a lawful purpose connected with our functions and activities of administering the National Internal Revenue Code (NIRC) of 1997, as amended, and other existing tax laws. 
        <br/><br/>
        <span class="font-weight-bolder">WHEN WE COLLECT PERSONAL INFORMATION</span>
        <br/><br/>
        We collect personal information directly from you when you register and use our online services.
        <br/><br/>
        We also collect personal information from third parties:
        <br/><br/>
        Take note that the NIRC of 1997, as amended, allows the Commissioner of Internal Revenue to collect personal information about a taxpayer from other people, entities and government offices subject to limitation provided for by existing laws. 
        <br/><br/>
        Third party information allows the BIR to ascertain the correctness of any returns, or in making a return when none has been made, or in determining the liability of any person for any internal revenue tax, or in collecting any such liability, or in evaluating tax compliance.
        <br/><br/>
        <span class="font-weight-bolder">LIMITS ON USE AND DISCLOSURE OF YOUR PERSONAL INFORMATION</span>
        <br/><br/>
        We only use and disclose personal information in connection with our lawful functions and activities of administering the NIRC of 1997, as amended, and other existing tax laws, and in accordance with existing legislations such as Republic Act (RA) No. 10173, or the Data Privacy Act of 2012, and RA No. 10021, or the Exchange of Information on Tax Matters Act of 2009.
        <br/><br/>
        The personal information we collect may be used to:
        <br/><br/>
        <ul style="padding-left:40px;">
          <li>administer the NIRC of 1997, as amended, and other existing tax laws</li>
          <li>update BIR database or records</li>
          <li>provide to other government agencies which are entitled to the information under existing</li>
          <li>contact you, including sending you information electronically</li>
        </ul>
        <br/>
        <span class="font-weight-bolder">HOW WE KEEP YOUR PERSONAL INFORMATION SECURE</span>
        <br/><br/>
        We respect your privacy and keep your information confidential unless we are lawfully required or allowed to disclose it or that you give your written consent to such disclosure.  
        <br/><br/>
        Under Section 270 of the NIRC of 1997, as amended, BIR personnel cannot divulge information collected from taxpayers concerning the latter’s business, income or estate, as well as the secrets, operation, style or work, or apparatus of any manufacturer or producer, or confidential information regarding the business of any taxpayer. There are, however, exceptions, namely:
        <br/><br/>
        <ul style="padding-left:40px;">
          <li>disposition of income tax returns under Section 71 of the NIRC, as amended</li>
          <li>disclosure of income tax returns under Section 26 of RA 6388 (Election Code) in case of an individual who files a certificate of candidacy and executes a waiver for the examination of his returns</li>
          <li>information given by the BIR pursuant to a request by a foreign tax authority under an existing treaty pursuant to RA 10021</li>
        </ul>
        <br/>
        The Data Privacy Act of 2012 clearly provides that personal data of an individual shall never be collected and processed without his or her consent, unless otherwise provided by law. 
        <br/><br/>
        We wish to emphasize that we have created and maintained a secure environment for the protection of your personal information and records. When we collect this information, it is kept safe and secure. We use reasonable security safeguards to protect information from loss, unauthorized access, use or disclosure.
        <br/><br/>
        <span class="font-weight-bolder">WEB BROWSER COOKIES OF OUR WEBSITE</span>
        <br/><br/>
        Our website, atg.bir.gov.ph, may use “cookies” where a small data file is sent to your browser to store and track information about you when you enter our website. Usage of a cookies is not linked to any personally identifiable information on our website. You can choose to accept or decline cookies. You can modify your browser setting to decline cookies because most web browsers automatically accept cookies. This, however, may prevent you from taking full advantage of the website.
        <br/><br/>
        <span class="font-weight-bolder">LINK TO OTHER WEBSITES</span>
        <br/><br/>
        Our website may contain links to and from websites of government departments and other organizations. This Privacy Policy, only applies to atg.bir.gov.ph. Websites other than the BIR website may have privacy and user policies that deviate from this one. We encourage you to likewise take time to read their site policies. Also, we recommend that you familiarize yourself with the Data Privacy Act of 2012.
        <br/><br/>
        <span class="font-weight-bolder">RIGHTS OF THE DATA SUBJECT</span>
        <br/><br/>
        Under the Data Privacy Act of 2012, people whose personal information is collected and processed are called data subjects. We are duty bound to observe and respect your privacy rights, including your right to information, right to access, right to correct, right to remove, right to damages and right to data portability. 
        <br/><br/>
        <span class="font-weight-bolder">FEEDBACK ON THE BUREAU’S PRIVACY NOTICE</span>
        <br/><br/>
        For your suggestion and feedback on this Privacy Notice, please send your email to bir_dpo@bir.gov.ph      
      </p>
      <!-- end:: Content -->
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
  mounted() {},
  computed: {
  }
};
</script>
